export const getExpressshipping = (
  delivery_day_start: number | null,
  delivery_day_end: number | null
): boolean => {
  if (delivery_day_start && delivery_day_end) {
    return delivery_day_start === 1 && delivery_day_end === 3;
  }
  return false;
};
